import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnBB: CultureInfo = {
  name: 'en-BB',
  displayName: 'English (Barbados)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-BB',
  parent: CultureInfoEn
};
